import { createSlice } from "@reduxjs/toolkit";
import { studentLessonsFilter, getMyLessons } from "redux/actions";
import { LessonModel } from "redux/models/home";
import { MyLesson } from "services/service-models";

export interface IStudentLessons {
  studentLessons: LessonModel[] | null;
  myLessons: MyLesson[] | null;
  loading: boolean;
}

const initial: IStudentLessons = {
  studentLessons: null,
  myLessons: null,
  loading: false,
};

export const studentLessonsSlice = createSlice({
  name: "studentsLessons",
  initialState: initial,
  reducers: {},
  extraReducers: (builder) => {
    // studentLessonsFilter
    builder.addCase(studentLessonsFilter.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(studentLessonsFilter.fulfilled, (state, action) => {
      state.loading = false;
      state.studentLessons = action.payload;
    });
    builder.addCase(studentLessonsFilter.rejected, (state, action) => {
      state.loading = false;
      state.studentLessons = null;
    });

    // getMyLessons
    builder.addCase(getMyLessons.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getMyLessons.fulfilled, (state, action) => {
      state.loading = false;
      state.myLessons = action.payload;
    });
    builder.addCase(getMyLessons.rejected, (state, action) => {
      state.loading = false;
      state.myLessons = null;
    });
  },
});

export const {} = studentLessonsSlice.actions;

export default studentLessonsSlice.reducer;
